import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStorage } from 'src/storage/local.storage';
import { SessionStorage } from 'src/storage/session.storage';

@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {
  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (LocalStorage.Token) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${LocalStorage.Token}`
        }
      })
    }
    else if (SessionStorage.Token) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${SessionStorage.Token}`
        }
      })
    }
    return next.handle(req);
  }
}
